import React, { forwardRef } from 'react';
import CarDisplayCardClient from '@/components/shared/car-details-card/car-details-car-client.component';
import { AVAILABLE_LANGUAGES } from '@/constants';
import { CarListingData } from '@/types/cars.types';
import { TFunction } from 'i18next';
import Typography from '@/components/shared/typography/typography.component';
import Box from '@/components/shared/Box/Box';

interface SimilarCarsSectionProps {
    similarCars: CarListingData[];
    carCardLocalizations: Record<string, string>;
    lang: AVAILABLE_LANGUAGES;
    t: TFunction;
    imgs: string[];
    isVisible: boolean;
}

export const SimilarCarsSection = forwardRef<
    HTMLDivElement,
    SimilarCarsSectionProps
>(({ similarCars, carCardLocalizations, lang, t, imgs, isVisible }, ref) => {
    const listSimilarCar = (item: CarListingData, index: number) => {
        return (
            <CarDisplayCardClient
                carCardLocalizations={carCardLocalizations}
                lang={lang}
                carData={item}
                id={item.id}
                key={item.id}
                cardTitle={`${t(item.make)} ${item.year} ${item.model}`}
                carName={item.sfVehicleName}
                trim={item.trim}
                installmentPrice={item?.installmentPrice}
                totalPrice={item.sylndrSellingPrice}
                kilometers={item.kilometers}
                year={item.year}
                transmission={item.transmission}
                images={item?.images.length !== 0 ? item?.images : imgs}
                isReserved={item.isReserved}
                make={item.make}
                model={item.model}
                sourceScreen={'Car Profile'}
                appliedFilter={false}
                appliedSort={false}
                position={index + 1}
                isPurchaseInProgress={item.isPurchaseInProgress}
                discountPrice={item?.discountPrice}
                isNewlyAdded={item?.isNewlyAdded}
                tags={item.tags}
            />
        );
    };

    return (
        <Box ref={ref}>
            {!isVisible ? (
                <></>
            ) : (
                <>
                    <Typography
                        className="text-gray-900 md:absolute md:top-0 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 opacity-100 bg-white px-2 mb-3 md:mb-0 pt-[18px] md:pt-0"
                        variant={'body1SemiBold'}
                    >
                        {t('Similar Cars')}
                    </Typography>
                    <div className="md:mt-12 mt-8 grid gap-x-4 gap-y-12 grid-cols-1 md:grid-cols-2 [@media(min-width:1101px)]:grid-cols-4 w-full">
                        {similarCars
                            ?.slice(0, 8)
                            .map((item: CarListingData, index: number) => (
                                <div key={item.id}>
                                    {listSimilarCar(item, index)}
                                </div>
                            ))}
                    </div>
                </>
            )}
        </Box>
    );
});

SimilarCarsSection.displayName = 'SimilarCarsSection';
